/**
 * Organization membership roles.
 *
 * Single source of truth for the role values an admin can assign to an
 * organization member. Mirrors the server's ROLE_HIERARCHY in
 * server/lib/constants.js — keep the two in sync.
 */
export const ORG_ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'coach', label: 'Coach' },
  { value: 'staff', label: 'Staff' },
  { value: 'guardian', label: 'Guardian' },
  { value: 'student', label: 'Student' }
]

export const ORG_ROLE_VALUES = ORG_ROLES.map((r) => r.value)

export default ORG_ROLES
